// @flow
import * as React from 'react';
import type { UGCSection } from './UGCSection';
import { PwrMediaUgcMetaInfo, ClientMediaUgcMetaInfo } from './UgcMetaInfo';
import AuthorInfo from './AuthorInfo';
import ReviewSection from './ReviewSection';
import CollapsedBlock from './CollapsedBlock';
import UGC from '../../models/Ugc';
import UserGeneratedTextContainer from 'components/ContentSection/UserGeneratedTextContainer';
import UgcLinkContext, { UgcLinkButton } from 'containers/UgcLinkContext';

const provideCollapsedContent = (ugc, options, collapsedContentProps) => {
  const parentUgc = UGC.getRelatedItemByType(ugc, 'Review');

  if (!parentUgc /* || options.program === 'client'*/) {
    return null;
  }

  const { onClick, open } = collapsedContentProps;
  const MetaInfoComponent =
    options.program === 'pwr' ? PwrMediaUgcMetaInfo : ClientMediaUgcMetaInfo;

  return (
    <CollapsedBlock label="Original Review" open={open} onClick={onClick}>
      <div className="mh4 mv3">
        <ReviewSection.Header ugc={parentUgc} options={options} />
      </div>
      <ReviewSection.Content ugc={parentUgc} options={options} />
      <MetaInfoComponent
        key="review-embed-attr"
        model={ugc}
        parentModel={parentUgc}
      />
      {options.program === 'client' && (
        <UgcLinkContext.Consumer>
          {linker => (
            <div className="mh4 dib">
              <UgcLinkButton
                href={linker(parentUgc)}
                label="View Original Review"
              />
            </div>
          )}
        </UgcLinkContext.Consumer>
      )}
    </CollapsedBlock>
  );
};

const ResponseSection: UGCSection = {
  Header: props => null,

  Content: ({ ugc }) => (
    <div className="mb4 mh4">
      <h3 className="mb0 f3">{ugc.catalog.group_name + ' Response'}</h3>
      <AuthorInfo ugc={ugc} />
      <p>
        <UserGeneratedTextContainer text={ugc.text} />
      </p>
    </div>
  ),

  getRelatedContent: (ugc, option) => null,

  provideCollapsedContent,
};

export default ResponseSection;



// WEBPACK FOOTER //
// ./src/components/ContentSection/ResponseSection.js